import Swal from 'sweetalert2';

// Generated initials avatars (shown when there is no photo, or it failed to
// load) have nothing worth enlarging.
const isPlaceholder = (src) => !src || src.includes('ui-avatars.com');

/**
 * onClick handler for an <img>: opens the image it is currently showing in a
 * full-size modal. Reads the rendered src so an onError fallback is respected.
 * Stops propagation so it can sit inside clickable rows/cards.
 */
export function previewImageOnClick(e, title) {
    const src = e.currentTarget?.currentSrc || e.currentTarget?.src;
    if (isPlaceholder(src)) return;
    e.stopPropagation();
    e.preventDefault();

    Swal.fire({
        title: title || undefined,
        imageUrl: src,
        imageAlt: title || 'Image',
        width: 'auto',
        padding: '1rem',
        showConfirmButton: false,
        showCloseButton: true,
        didOpen: (popup) => {
            const img = popup.querySelector('.swal2-image');
            if (img) Object.assign(img.style, { maxWidth: '85vw', maxHeight: '75vh', objectFit: 'contain', margin: '0 auto' });
        },
    });
}

/** Pointer cursor only when there is a real photo to open. */
export const previewCursor = (src) => (isPlaceholder(src) ? undefined : 'zoom-in');
